import { render, staticRenderFns } from "./app-cookie-consent.vue?vue&type=template&id=46b08238&"
import script from "./app-cookie-consent.vue?vue&type=script&lang=js&"
export * from "./app-cookie-consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports